import Vue from 'vue'
import Router from 'vue-router'
import Business from '@/pages/business/Business';
import Webot from '@/pages/webot/Webot';
import Feedback from '@/pages/feedback/Feedback';
import Satisfaction from '@/pages/satisfaction/Satisfaction';
import Verify from '@/pages/verify/Verify';
import Recorder from '@/components/recorder-demo/Recorder';
import { http } from '@/services/http';
import { dataHandle } from '@/services/data-handle.js'
import { setTitle } from './setTitle'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env['BASE_PATH'],
  routes: [
    {
      path: '/chat',
      name: 'business',
      component: Business,
      meta: {
        title: 'webot'
      }
    },
    {
      path: '/chat/bot',
      name: 'webot',
      component: Webot,
      meta: {
        title: 'webot'
      }
    },
    {
      path: '/chat/feedback',
      name: 'feedback',
      component: Feedback,
      meta: {
        title: 'webot'
      }
    },
    {
      path: '/chat/recorder',
      name: 'recorder',
      component: Recorder,
      meta: {
        title: 'webot'
      }
    },
    {
      path: '/chat/satisfaction',
      name: 'satisfaction',
      component: Satisfaction,
      meta: {
        title: 'webot'
      }
    },
    {
      path: '/chat/verify',
      name: 'verify',
      component: Verify,
      meta: {
        title: 'webot'
      }
    },
  ]
})
router.beforeEach(async (to, form, next)=>{
  if (to.name == 'satisfaction') {
    next()
    return;
  }
  let accessKey;
  if(to.query.accessKey) sessionStorage.setItem('accessKey', to.query.accessKey);
  if(to.query.userId) dataHandle.setCookie('X-User-Mobile',to.query.userId);
  if(to.query.showPageHeader) {
    sessionStorage.setItem('showPageHeader',to.query.showPageHeader);
    if(to.query.pageHeader) sessionStorage.setItem('pageHeader',to.query.pageHeader);
    let barHeight = 20;
    if(to.query.statusBarHeight && to.query.statusBarHeight != '') {
      barHeight = to.query.statusBarHeight;
      if (isNaN(barHeight) || barHeight < 20) {
        barHeight = 20;
      }
      if (barHeight > 60) {
        barHeight = 60;
      }
    }
    sessionStorage.setItem('statusBarHeight',barHeight);
  }
  if (form.name != 'webot' && form.name != 'business') {
    accessKey = to.query.accessKey;
    if (!accessKey) {
      accessKey = sessionStorage.getItem('accessKey');
    }
    await getMenuList(accessKey);
  }
  if (!sessionStorage.getItem('menuList') || !sessionStorage.getItem('skillGroups')) {
    accessKey = to.query.accessKey;
    if (!accessKey) {
      accessKey = sessionStorage.getItem('accessKey');
    }
    await getMenuList(accessKey);
  }
  if (to.name == 'business') {
    let menuList = JSON.parse(sessionStorage.getItem('menuList'));
    // 判断是否允许进入切换业务页面
    let exist= false;
    for (var i = 0; i < menuList.length; i++) {
      if (menuList[i].code == 'business' && menuList[i].isShow) {
        exist = true;
        break;
      }
    }
    if (exist) {
      next();
    }else{
      const skillGroups = JSON.parse(sessionStorage.getItem('skillGroups'));
      if (skillGroups.length > 0) {
        const item = skillGroups[0];
        sessionStorage.setItem('business',item.id);
        const businessName = item.alias_name || item.name;
        sessionStorage.setItem('businessName', businessName);
        sessionStorage.setItem('businessType', item.type || 1);
        next({
          path: '/chat/bot',
          query: to.query
        });
      }
    }
  }else{
    next();
  }
})
router.afterEach(route => {
  let title = route.query.title;
  if (!title) {
    title = sessionStorage.getItem('botName');
  }
  let pageTitle = title || 'webot';
  setTitle(pageTitle);
});

/**
 * 获取机器人附件功能列表
 */
const getMenuList = async function(accessKey) {
    let res = await http.get(`/config?accessKey=${accessKey}`);
    if(res.data) {
      let menuList = res.data.menuList || [];
      let skillGroups = res.data.skillGroups || [];
      let docLabels = res.data.docLabels || [];
      sessionStorage.setItem('menuList', JSON.stringify(menuList));
      sessionStorage.setItem('skillGroups', JSON.stringify(skillGroups));
      sessionStorage.setItem('docLabels', JSON.stringify(docLabels));
    }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js